import { toast as sonnerToast } from "sonner";
import { shortenToastText } from "@/hooks/use-toast";

type ToastData = Parameters<typeof sonnerToast>[1];

const getShortData = (data?: ToastData): ToastData => {
  if (!data || typeof data !== "object") return data;

  return {
    ...data,
    description:
      typeof data.description === "string"
        ? shortenToastText(data.description)
        : data.description,
  };
};

const getShortMessage = <T,>(message: T): T =>
  typeof message === "string" ? (shortenToastText(message, 48) as T) : message;

const shortToast = ((
  message: Parameters<typeof sonnerToast>[0],
  data?: ToastData
) => sonnerToast(getShortMessage(message), getShortData(data))) as typeof sonnerToast;

export const toast = Object.assign(shortToast, sonnerToast, {
  success: ((message, data) =>
    sonnerToast.success(getShortMessage(message), getShortData(data))) as typeof sonnerToast.success,
  error: ((message, data) =>
    sonnerToast.error(getShortMessage(message), getShortData(data))) as typeof sonnerToast.error,
  info: ((message, data) =>
    sonnerToast.info(getShortMessage(message), getShortData(data))) as typeof sonnerToast.info,
  warning: ((message, data) =>
    sonnerToast.warning(getShortMessage(message), getShortData(data))) as typeof sonnerToast.warning,
  message: ((message, data) =>
    sonnerToast.message(getShortMessage(message), getShortData(data))) as typeof sonnerToast.message,
});
